/* eslint-disable jsx-a11y/anchor-is-valid */
import { useMemo, VFC } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { dashBoardPaths } from "../routes";

type Props = { isSettingDisplay: boolean };
const Tabs: VFC<Props> = ({ isSettingDisplay }) => {
  const location = useLocation();

  const tabsData = useMemo(() => {
    const tabs: { title: string; path: string }[] = [
      {
        title: "どう思われてるかを知る",
        path: dashBoardPaths.analysis,
      },
      // {
      //   title: "客層を知る",
      //   path: dashBoardPaths.customers,
      // },
      {
        title: "直接見る",
        path: dashBoardPaths.reviews,
      },
    ];

    if (isSettingDisplay) {
      tabs.push({
        title: "設定",
        path: dashBoardPaths.setting,
      });
    }
    return tabs;
  }, [isSettingDisplay]);

  return (
    <div className="tabs is-boxed">
      <ul>
        {tabsData.map((tabData) => (
          <li
            className={
              location.pathname.includes(tabData.path) ? "is-active" : ""
            }
            key={tabData.title}
          >
            <Link to={tabData.path}>
              <span>{tabData.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Tabs;
